import * as yup from 'yup';

export const commentsSchema = yup.object().shape({
    text: yup
        .string()
        .required("mandatory"),
});

export const createNoteSchema = yup.object().shape({
    // customer_po: yup
    //     .string()
    //     .required("customerPORequired"),
    // order_name: yup
    //     .string()
    //     .required("orderNameRequired"),
    text: yup
        .string()
        .required("noteRequired"),
});

export const messageSchema = yup.object().shape({
    text: yup
        .string()
        .required("messageBodyRequired"),
});

export const quotesSchema = yup.object().shape({
    description: yup.string().notRequired(),
    invoice_number: yup
        .string()
        .required('Invoice number is required'),
    quote: yup
        .number()
        .typeError('Quote value must be a number')
        .required('Quote is Required')
        .min(0.01, 'Quote must be at least 0.01'),
    parts: yup.array().of(
        yup.object().shape({
            description: yup
                .string()
                .required('Description/Part is required'),
            quantity: yup
                .number()
                .typeError('Quantity must be a number')
                .required('Quantity is required')
                .min(1, 'Quantity must be at least 1'),
            fulfill_date: yup.date().required('Fulfill date is required'),
            value: yup.number()
                .typeError('Price must be a number')
                .required('Price is required')
                .min(0.01, 'Price must be at least 0.01'),
        })
    ).min(1, 'At least one part is required'),
});

export const childAccountSchema = yup.object().shape({
    location_name: yup.string().required('locationNameRequired'),
    location: yup.string().required('locationRequired'),
    country_code: yup.string().required('countryCodeRequired'),
    mobile_number: yup.string()
        .required("mobileNumberRequired"),
    admin_email_1: yup.string().email('validEmail').required('adminEmail1Required'),
    admin_name_1: yup.string().required('adminName1Required'),
    admin_email_2: yup.string().email('validEmail'),
    tax_percentage: yup.number().required('taxPercentageRequired').min(0).max(100),
});

export const createWhiteLabelPartnerScheme = yup.object().shape({
    company_name: yup.string().required("companyNameRequired"),
    contact_details: yup.string().required("contactNumberRequired"),
    email: yup.string().email('validEmail').required('emailRequired'),
    role: yup.string().required("roleRequired"),
});

export const verifyChildAccountSchema = yup.object().shape({
    new_password: yup
        .string()
        .trim()
        .required("newPasswordRequired")
        .min(12, "Password must be at least 12 characters")
        .max(128, "Password must be at most 128 characters")
        .matches(/\d/, "Password must contain a number")
        .matches(/[A-Z]/, "Password must contain an uppercase letter")
        .matches(/[a-z]/, "Password must contain a lowercase letter")
        .matches(/[!@#$%^&*]/, "Password must contain a special character"),
    confirm_password: yup
        .string()
        .trim()
        .required("confirmPasswordRequired")
        .oneOf([yup.ref("new_password"), null], "passwordMatch"),
    email: yup.string().email('validEmail').required('emailRequired'),
    key: yup.string().required("yeyRequired"),
});

export const inviteTeamSchema = yup.object().shape({
    first_name: yup
        .string()
        .required("firstNameRequired"),
    last_name: yup
        .string()
        .required("lastNameRequired"),
    email: yup.string().email('validEmail').required('emailRequired'),
    // country_code: yup.string().required('countryCodeRequired'),
    phone_number: yup.string()
        .required("mobileNumberRequired")
        .matches(/^(\+\d{1,3})?\d{6,14}$/, "Phone Number should be in international format"),
    role: yup.string().required("roleRequired"),
});